"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const AccountSwitcher_1 = __importDefault(require("./AccountSwitcher"));
const LoadingBar_1 = __importDefault(require("./LoadingBar"));
const DecodableLogo_1 = __importDefault(require("./icons/DecodableLogo"));
const LinkContext_1 = require("./LinkContext");
function AppBar({ anonymous, disableLogo, user, userLoading, activeAccount, homeHref, onLogIn, renderNav, renderActions, isLoading, accountSwitcherPopoverProps, } = { userLoading: false }) {
    const LinkComponent = (0, LinkContext_1.useLink)();
    return ((0, jsx_runtime_1.jsxs)(AppBar_1.default, Object.assign({ elevation: 0, position: "sticky" }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: {
                    display: "grid",
                    placeItems: "stretch left",
                    gridTemplateAreas: '"left center right"',
                    gridTemplateColumns: "min-content auto 1fr",
                } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                            flexGrow: 1,
                            flexDirection: "row",
                            display: "flex",
                            justifyContent: "flex-start",
                        } }, { children: disableLogo ? null : ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ href: homeHref || "/", component: LinkComponent, sx: { px: 2, "&:hover": { bgcolor: "inherit" } } }, { children: (0, jsx_runtime_1.jsx)(DecodableLogo_1.default, { style: { width: "16ch" } }) }))) })), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                            placeSelf: "stretch",
                            display: "grid",
                        } }, { children: renderNav && renderNav() })), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: {
                            placeSelf: "stretch end",
                            display: "flex",
                        } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                                    placeSelf: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: 0,
                                    paddingRight: "0.5ch",
                                    borderRight: "1px solid rgba(0,0,0,0.1)",
                                    borderRadius: 0,
                                    height: "100%",
                                } }, { children: renderActions && renderActions() })), !anonymous && !userLoading && user && ((0, jsx_runtime_1.jsx)(AccountSwitcher_1.default, { user: user, activeAccount: activeAccount, popoverProps: accountSwitcherPopoverProps, buttonProps: {
                                    sx: {
                                        height: "100%",
                                    },
                                } })), !anonymous && !userLoading && user == undefined && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: { height: "100%", borderRadius: 0 }, onClick: onLogIn }, { children: "Sign In" })))] }))] })), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), isLoading ? (0, jsx_runtime_1.jsx)(LoadingBar_1.default, {}) : null] })));
}
exports.default = AppBar;
